/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/WorkspaceMindmapNodePaginationSlice', 'model/WorkspaceMindmapNodeType'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./WorkspaceMindmapNodePaginationSlice'), require('./WorkspaceMindmapNodeType'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkspaceMindmapReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.WorkspaceMindmapNodePaginationSlice, root.ForStractionServiceApi.WorkspaceMindmapNodeType);
  }
}(this, function(ApiClient, WorkspaceMindmapNodePaginationSlice, WorkspaceMindmapNodeType) {
  'use strict';




  /**
   * The WorkspaceMindmapReport model module.
   * @module model/WorkspaceMindmapReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>WorkspaceMindmapReport</code>.
   * @alias module:model/WorkspaceMindmapReport
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>WorkspaceMindmapReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorkspaceMindmapReport} obj Optional instance to populate.
   * @return {module:model/WorkspaceMindmapReport} The populated <code>WorkspaceMindmapReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('WorkshopID')) {
        obj['WorkshopID'] = ApiClient.convertToType(data['WorkshopID'], 'Integer');
      }
      if (data.hasOwnProperty('NodeTypes')) {
        obj['NodeTypes'] = ApiClient.convertToType(data['NodeTypes'], [WorkspaceMindmapNodeType]);
      }
      if (data.hasOwnProperty('Nodes')) {
        obj['Nodes'] = WorkspaceMindmapNodePaginationSlice.constructFromObject(data['Nodes']);
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('PreviewImageTakenAt')) {
        obj['PreviewImageTakenAt'] = ApiClient.convertToType(data['PreviewImageTakenAt'], 'Date');
      }
      if (data.hasOwnProperty('PreviewBlobStorageUrl')) {
        obj['PreviewBlobStorageUrl'] = ApiClient.convertToType(data['PreviewBlobStorageUrl'], 'String');
      }
      if (data.hasOwnProperty('IsActive')) {
        obj['IsActive'] = ApiClient.convertToType(data['IsActive'], 'Boolean');
      }
      if (data.hasOwnProperty('WorkshopWidgetID')) {
        obj['WorkshopWidgetID'] = ApiClient.convertToType(data['WorkshopWidgetID'], 'Integer');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} WorkshopID
   */
  exports.prototype['WorkshopID'] = undefined;
  /**
   * @member {Array.<module:model/WorkspaceMindmapNodeType>} NodeTypes
   */
  exports.prototype['NodeTypes'] = undefined;
  /**
   * @member {module:model/WorkspaceMindmapNodePaginationSlice} Nodes
   */
  exports.prototype['Nodes'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Date} PreviewImageTakenAt
   */
  exports.prototype['PreviewImageTakenAt'] = undefined;
  /**
   * @member {String} PreviewBlobStorageUrl
   * @default ''
   */
  exports.prototype['PreviewBlobStorageUrl'] = '';
  /**
   * @member {Boolean} IsActive
   * @default false
   */
  exports.prototype['IsActive'] = false;
  /**
   * @member {Integer} WorkshopWidgetID
   */
  exports.prototype['WorkshopWidgetID'] = undefined;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


